import { dsColorNew } from "@palette"


// A field with an error keeps its message and appears at the same moment; its outline is a softer red
const overrideInputStyles = () => ({
	MuiOutlinedInput: {
		styleOverrides: {
			root: {
				'&.Mui-error .MuiOutlinedInput-notchedOutline': {
					borderColor: dsColorNew.dangerSoft,
				},
			},
		},
	},
})

export default overrideInputStyles
